module.exports = __webpack_public_path__ + "img/hypenation.74e9cbfb.png";